import React, { useCallback, useState } from 'react';
import { Alert, Icon, Input, InputGroup } from 'rsuite';
import firebase from 'firebase/app';
import { useProfile } from '../../../context/profile.context';
import { useParams } from 'react-router';
import { database } from '../../../utils/firebase';
import AttachmentBtnModal from './AttachmentBtnModal';
import AudioMessageBtn from './AudioMessageBtn';

const assembleMessage = (profile, chatID) => {

    return {
        roomID: chatID,
        author: {
            name: profile.name,
            uid: profile.uid,
            createdAt: profile.createdAt,
            ...(profile.avatar ? {avatar: profile.avatar} : {})
        },
        createdAt: firebase.database.ServerValue.TIMESTAMP,
        likeCount: 0
    }
}

// ------------------------------------------------------- //

const Bottom = () => {

    const [input, setInput] = useState('');
    const [isLoading, setLoading] = useState(false);

    const {profile} = useProfile();
    const {chatID} = useParams();

    const onInputChange = useCallback((value) => {
        setInput(value);
    }, []);

    const onSendClick = async () => {
        
        const input_ = input;
        setInput('');

        if(input_.trim() === '') return;

        const msgData = assembleMessage(profile, chatID);
        msgData.text = input_;

        const updates = {};
        const messageID = database.ref('messages').push().key;

        // atomic updates
        updates[`/messages/${messageID}`] = msgData;
        updates[`/rooms/${chatID}/lastMessage`] = {
            ...msgData,
            msgID: messageID
        };

        setLoading(true);

        try {
            await database.ref().update(updates);
            setLoading(false);

        } catch (error) {
            
            setLoading(false);
            Alert.error(error.message, 4000);            
        }
    }

    // ------------------------------------------------------- //

    const afterUpload = useCallback(async (files) => {

        setLoading(true);

        const updates = {};

        files.forEach(file => {
            
            const msgData = assembleMessage(profile, chatID);
            msgData.file = file;
        
            const messageID = database.ref('messages').push().key;
            updates[`/messages/${messageID}`] = msgData;

        });

        const lastMsgID = Object.keys(updates).pop();
        updates[`/rooms/${chatID}/lastMessage`] = {
            ...updates[lastMsgID],
            msgID: lastMsgID
        };

        try {

            await database.ref().update(updates);
            setLoading(false);

        } catch (error) {
            
            setLoading(false);
            Alert.error(error.message, 4000);            
        }

    }, [chatID, profile]);

    // ------------------------------------------------------- //

    return (
        <div>

            <InputGroup>

                <AttachmentBtnModal afterUpload={afterUpload}/>
                <AudioMessageBtn afterUpload={afterUpload}/>

                <Input placeholder="Write a new message..." onChange={onInputChange} value={input} onPressEnter={onSendClick}/>
                <InputGroup.Button color="blue" disabled={isLoading} onClick={onSendClick}>
                    <Icon icon="send" />
                </InputGroup.Button>

            </InputGroup>

        </div>
    )
}

export default Bottom;